// calculate the offset.
export const calculateElementOffset = function( options ) {
	let scaledHeight, scaledWidth;
	const userOptions = options || {
		container: null,
		width: 0,
		height: 0,
		dimension: 0,
		use_dimension: false,
	};

	if ( userOptions.container.attr( 'data-id' ) ) {
		const windowWidth = window.innerWidth;
		const windowHeight = window.innerHeight;

		const expectedWidth = windowWidth * 0.2;
		const expectedHeight = windowHeight * 0.2;

		const targetWidth = windowWidth - expectedWidth;
		const targetHeight = windowHeight - expectedHeight;

		const ratio = userOptions.width / userOptions.height;

		if ( ratio > targetWidth / targetHeight ) {
			scaledWidth = targetWidth;
			scaledHeight = targetWidth / ratio;
		} else {
			scaledHeight = targetHeight;
			scaledWidth = targetHeight * ratio;
		}
	} else {
		scaledWidth = userOptions.width;
		scaledHeight = userOptions.height;
	}

	let dimension = {};
	if ( userOptions.use_dimension ) {
		dimension = {
			cw: `${ userOptions.dimension * scaledWidth }px`,
			ch: `${ userOptions.dimension * scaledHeight }px`,
		};
	}

	return {
		w: `${ scaledWidth }px`,
		h: `${ scaledHeight }px`,
		...dimension,
	};
};

export function stripAllTags( htmlString ) {
	if ( ( htmlString === null ) || ( htmlString === '' ) ) {
		return '';
	}
	htmlString = htmlString.toString();

	// Remove HTML tags
	let cleanedHtml = htmlString.replace( /<\/?[^>]+(>|$)/g, '' );

	// Replace all double quote.
	cleanedHtml = cleanedHtml.replace( /"/g, '\\\"' );
	cleanedHtml = cleanedHtml.replace( /'/g, '\\\'' );
	cleanedHtml = cleanedHtml.replace( /\\\\/g, '\\' );

	return cleanedHtml.trim();
}
